import { isError } from "util";

import { Alert, Button, Flex, Popup } from "@fluentui/react-northstar";
import React, { useState } from "react";

type Props = {
  content: React.ReactNode;
  open: boolean | undefined;
  target: React.ReactNode;
  onConfirmedAction: () => Promise<void | Error>;
  onCancel: () => void;
};

export const ConfirmActionPopup: React.FC<Props> = ({
  open,
  content,
  target,
  onConfirmedAction,
  onCancel,
}) => {
  const [isRunning, setIsRunning] = useState<boolean>();
  const [error, setError] = useState<string>();

  return (
    <Popup
      open={open}
      target={target as HTMLElement}
      onOpenChange={() => onCancel()}
      position="above"
      content={
        <Flex
          column
          style={{ maxWidth: "300px" }}
          gap="gap.small"
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <Alert content={content} warning />
          <Button
            content="Confirm"
            fluid
            primary
            disabled={isRunning}
            loading={isRunning}
            onClick={async e => {
              e.stopPropagation();
              setError(undefined);
              setIsRunning(true);
              const result = await onConfirmedAction();
              setIsRunning(false);
              if (isError(result)) {
                setError(result.message);
              }
            }}
          />
          {error && <Alert danger content={error} attached="bottom" />}
        </Flex>
      }
    />
  );
};
